import { isPartnerRoute } from '@/constants/routes'

export type SignupPageArea =
  | 'ai-model'
  | 'photoshoot'
  | 'projects'
  | 'create'
  | 'ai-studio'
  | 'editor'
  | 'partner'
  | 'other'

export function getSignupPageArea(pathname?: string): SignupPageArea {
  const path =
    pathname ?? (typeof window !== 'undefined' ? window.location.pathname : '')

  if (path.startsWith('/create/ai-models')) return 'ai-model'
  if (path.startsWith('/create/photoshoots')) return 'photoshoot'
  if (path.startsWith('/create/projects')) return 'projects'
  if (path.startsWith('/create')) return 'create'
  if (path.startsWith('/ai-studio')) return 'ai-studio'
  if (isPartnerRoute(path)) return 'partner'
  if (path.startsWith('/design/') || path === '/') return 'editor'
  return 'other'
}
